import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
interface SuccessScreenProps {
  name: string;
  objective: string;
  onReset: () => void;
}
export function SuccessScreen({
  name,
  objective,
  onReset
}: SuccessScreenProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="max-w-2xl mx-auto bg-blanco-perla rounded-2xl p-8 md:p-12 shadow-premium text-center" data-id="element-200">
      <div className="flex justify-center mb-6" data-id="element-201">
        <div className="w-20 h-20 bg-dorado/10 rounded-full flex items-center justify-center" data-id="element-202">
          <CheckCircle2 className="w-12 h-12 text-dorado" data-id="element-203" />
        </div>
      </div>

      <h2 className="font-serif text-3xl md:text-4xl text-azul-profundo mb-4" data-id="element-204">
        ¡Diagnóstico enviado con éxito!
      </h2>

      <p className="text-gray-600 mb-8 text-lg" data-id="element-205">
        Gracias por tomarte el tiempo de completar tu Diagnóstico RenuevaTE_90,{' '}
        <span className="font-semibold text-azul-profundo" data-id="element-206">{name}</span>.
      </p>

      <div className="bg-white rounded-xl p-6 border border-plateado/50 mb-8 text-left" data-id="element-207">
        <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-208">
          Tu objetivo principal:
        </h3>
        <p className="text-azul-profundo italic font-serif text-xl border-l-4 border-dorado pl-4" data-id="element-209">
          "{objective}"
        </p>
      </div>

      <p className="text-gray-600 mb-10" data-id="element-210">
        Nuestro equipo revisará tus respuestas a detalle y nos pondremos en
        contacto contigo en las próximas 24-48 horas para indicarte el siguiente
        paso en tu camino hacia el despertar de tu cuerpo.
      </p>

      <button onClick={onReset} className="text-azul-profundo font-medium hover:text-dorado transition-colors underline underline-offset-4" data-id="element-211">
        Volver al inicio
      </button>
    </motion.div>;
}